import React from 'react'
import Catalog from './Catalog'

const Taste: React.FC = () => {
  return <Catalog />
}

export default Taste
